(function() {
'use strict';

angular
    .module('TR')
    .controller('AvailabilityMap', AvailabilityMap);

function AvailabilityMap($q, pageStrand, urlUtils, windowUtil, basketService, $scope, $routeParams, tripService, hotelCoordinates, broker, $location, resourceService, currentDestination) {
    const mc = this;

    mc.popup = false;
    mc.togglePopup = togglePopup;
    mc.mapReady = false;

    function togglePopup() {
        if (mc.coords == null) {
            loadCoordinates().then(function() {
                mc.popup = !mc.popup;
            });
        } else {
            mc.popup = !mc.popup;
        }
    }

    if ($location.search().pd === 'mp') {
        togglePopup();
    }

    broker.subscribe('AvailabilityMap', 'lightboxOpened', function() {
        mc.lightboxOpen = true;
    });

    broker.subscribe('AvailabilityMap', 'mapReady', function() {
        mc.mapReady = true;
    });

    function loadCoordinates() {
        function parseResults(data) {
            if (data == null) {
                return;
            }
            mc.centre = data.CentrePosition;
            mc.zoom = data.ZoomLevel;
            mc.coords = data.Hotels;
        }
        if ($routeParams.tripId) {
            mc.bookButton = function() {
                return resourceService.get('SELECTHOTELTEXT');
            };
            return tripService.getTrip($routeParams.tripId).then(function(trip) {
                broker.subscribe('AvailabilityMapCtrl', 'selectHotel', function(ev) {
                    basketService.selectHotel(trip.TripId, ev.data.hotel, trip.BasketId);
                });

                return trip.HotelsRequest ?
                    hotelCoordinates.getCoordinates(trip.HotelsRequest.AvailabilitySearchId).then(parseResults) :
                    $q.when();
            });
        }

        //if we are not already part of a trip, just go straight through to the hotel
        //landing parge
        broker.subscribe('AvailabilityMapCtrl', 'selectHotel', function(ev) {
            const hotel = ev.data.hotel;

            currentDestination.getCurrentDestination().then(function(dest) {
                const url = urlUtils.stripLeadingSlash(
                    pageStrand.adjustUrl(
                        urlUtils.appendExistingQueryString(hotel.Url || hotel.FriendlyUrl),
                        dest.PageStrand
                    )
                );
                if (TRPCONFIG.DeviceSettings.OpenHotelInNewWindow) {
                    windowUtil.open(url);
                } else {
                    $location.path(url);
                }
            });
        });
        mc.bookButton = function() {
            return resourceService.get('VIEWDETAILS');
        };
        return hotelCoordinates.getCoordinates().then(parseResults);
    }

    broker.subscribe('AvailabilityMap', 'hotelResultsModified', loadCoordinates);
    broker.subscribe('AvailabilityMap', 'hotelResultsRetrieved', loadCoordinates);

    $scope.$on('$destroy', () => {
        broker.unsubscribe('AvailabilityMap');
    });
}
})();
